// @ts-nocheck
import { Formio } from '@formio/angular';

const dateTime = (Formio as any).Components.components.datetime;
const Components = (Formio as any).Components;
const Utils = (Formio as any).Utils;
import * as _ from 'lodash';

const DEFAULT_FORMAT = 'yyyy-MM-dd hh:mm a';
// const ISO_8601_FORMAT = 'yyyy-MM-ddTHH:mm:ssZ';
// const CDN_URL = 'https://cdn.form.io/';

export default class CalendarWidget extends dateTime {

  constructor(settings, component, ...args) {
    super(settings, component, ...args);
    // this.settings = settings;
    // Change the format to map to the settings.
    if (settings.noCalendar) {
      settings.format = settings.format.replace(/yyyy-MM-dd /g, '');
    }
    if (!settings.enableTime) {
      settings.format = settings.format.replace(/ hh:mm a$/g, '');
    } else if (settings.time_24hr) {
      settings.format = settings.format.replace(/hh:mm a$/g, 'HH:mm');
    }
  }

  /**
   * Return the value of the selected date.
   *
   * @return {*}
   */
  getValue() {
    /* Formio adds time event if  component.enableTime set to false*/
    let data = JSON.parse(
      JSON.stringify(super.getValue()).replace(/"*\+\d+\D\d+/gm, ``)
    )
      .replace(/\..*Z/, ``)
      .replace(/T/, ` `)
    if (!this.component.enableTime) {
      data = data.split(' ')[0]
    }
    if (!this.calendar) {
      return data

      return super.getValue();
    }

    // Get the selected dates from the calendar widget.
    const dates = this.calendar.selectedDates;
    if (!dates || !dates.length) {
      return super.getValue();
    }

    if (!(dates[0] instanceof Date)) {
      return 'Invalid Date';
    }

    return this.getDateValue(dates[0], this.valueFormat);
  }

  /**
   * Set the selected date value.
   *
   * @param value
   */
  setValue(value) {
    value = value
      ? JSON.parse(JSON.stringify(value).replace(/"*\+\d+\D\d+/gm, ``))
        .replace(/\..*Z/, ``)
        .replace(/T/, ` `)
      : value;

    if (!this.calendar) {
      return super.setValue(value);
    }
    if (value) {
      if (
        this.settings.saveAs !== 'text' &&
        this.settings.readOnly &&
        !this.loadZones()
      ) {
        this.calendar.setDate(
          Utils.momentDate(value, this.valueFormat, this.timezone).toDate(),
          false
        );
      } else {
        this.calendar.setDate(
          Utils.moment(value, this.valueMomentFormat).toDate(),
          false
        );
      }
    } else {
      this.calendar.clear(false);
    }
  }

}

Components.setComponent('datetime', CalendarWidget);

